import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ad0ab9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header d-flex justify-content-between" }
const _hoisted_2 = {
  key: 0,
  class: "coaching-session-change-dialog__title m-0 pt-1 pt-md-0"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "coaching-session-change-dialog__content"
}
const _hoisted_6 = { class: "coaching-session-change-dialog__footer" }

import BsDialog from '@/components/BsDialog/BsDialog.vue'
import BsPlaceholder from '@/components/BsPlaceholder/BsPlaceholder.vue'
import BarButton from '@/components/BarButton'
import locales from './CoachingSessionAboutCoach.locales.en.json'
import XCircleIcon from '@/icons/XCircleIcon.vue'
import { CoachingSessionAboutCoachViewModel } from './CoachingSessionAboutCoach.interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionAboutCoach',
  props: {
    modelValue: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BsDialog, {
    "class-names": "coaching-session-change-dialog",
    "close-on-escape": "",
    "close-on-backdrop-click": ""
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.modelValue && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_unref(locales).title_about_coach) + " " + _toDisplayString(_ctx.modelValue.displayName), 1))
          : (_openBlock(), _createBlock(BsPlaceholder, {
              key: 1,
              pattern: "#####"
            })),
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, [
          _createVNode(XCircleIcon)
        ], 8, _hoisted_3)
      ])
    ]),
    footer: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(BarButton), {
          class: "button-close m-3 mt-1 me-0 me-md-3",
          mode: "outline",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(" <  Go Back ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.modelValue && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "coaching-session-change-dialog__content mt-4",
            innerHTML: _ctx.modelValue.message
          }, null, 8, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(BsPlaceholder, { pattern: "##### ############ ############ ........####" })
          ]))
    ]),
    _: 1
  }))
}
}

})